import {
  buildSort,
  buildRelevanceSortCriterion,
  SortOrder,
  buildFieldSortCriterion,
  Sort,
  SearchEngine,
} from '@coveo/headless';
import sitesHeadlessEngine from './sitesHeadlessEngine';

export const sitesRelevanceSortCriterion = buildRelevanceSortCriterion();

export const sitesAlphabeticalSortCriterion = buildFieldSortCriterion(
  'site_name',
  SortOrder.Ascending
);

export interface SitesHeadlessSort {
  sortController: Sort;
}

export const buildSitesHeadlessSort = (
  // eslint-disable-next-line @typescript-eslint/ban-types
  engine: SearchEngine<{}>
): SitesHeadlessSort => ({
  sortController: buildSort(engine, {
    initialState: { criterion: sitesRelevanceSortCriterion },
  }),
});

let cachedSort: SitesHeadlessSort | null = null;

/** Lazily builds and caches sort controller for the default sites engine. Client-side only. */
export const getSitesHeadlessSort = (): SitesHeadlessSort => {
  if (typeof window === 'undefined') {
    throw new Error('Sites headless sort must be initialized on the client');
  }

  if (!cachedSort) {
    cachedSort = buildSitesHeadlessSort(sitesHeadlessEngine);
  }

  return cachedSort;
};

type SitesSortCriterion =
  ReturnType<typeof buildRelevanceSortCriterion> | ReturnType<typeof buildFieldSortCriterion>;

export const getSitesSortCriteria = (): [string, SitesSortCriterion][] => [
  ['Most relevant', sitesRelevanceSortCriterion],
  ['Alphabetical', sitesAlphabeticalSortCriterion],
];
